function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAttachment = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 18.75a4 4 0 1 1-5.62-5.65l5.29-5.29a2.5 2.5 0 1 1 3.54 3.53l-4.49 4.48-1.06-1.06 4.48-4.48a1 1 0 0 0-1.41-1.41l-5.29 5.29A2.5 2.5 0 0 0 11 17.69l5.29-5.29a4 4 0 0 0-5.66-5.65l-4.5 4.48-1.06-1.06 4.48-4.49a5.5 5.5 0 0 1 7.78 7.78Z",
  style: {
    fill: "#262626"
  }
}));
export default SvgAttachment;